<template>
  <modal
    @update:show="ON_CLOSE_DIALOG"
    :show="open"
    size="lg"
    class="col-12"
    footerClasses="row justify-content-center"
  >
    <div class="row">
      <div class="col-md-4">
        <label>Status</label>
        <multiselect
          v-model="selected_status"
          placeholder="Selecionar Status"
          label="label"
          :options="SUPPORT_STATUS"
        />
      </div>
      <div class="col-md-4">
        <label>Data de Abertura</label>
        <el-date-picker
          v-model="selected_date"
          type="date"
          range-separator="-"
          start-placeholder="Data início"
          unlink-panels
          prefix-icon="fa fa-calendar"
          format="d 'de' MMMM 'de' yyyy"
        />
      </div>
      <div class="col-md-4">
        <label>Solicitante</label>
        <multiselect
          v-model="selected_claimant"
          placeholder="Selecionar Solicitante"
          label="name"
          :options="users"
          :disabled="!$can('index', 'support_bridge') && $can('show', 'support_bridge')"
        />
      </div>
    </div>
    <div class="row justify-content-end mb-2">
      <base-button type="secondary"class="mr-2 mt-2" @click="clearFilters">Limpar Filtros<i class=""></i></base-button>
      <base-button type="primary" class="mr-3 mt-2" @click="filter">Filtrar<i class="fas fa-filter"></i></base-button>
    </div>
    <CreateSupportDialog
      :open.sync="CREATE_SUPPORT_DIALOG"
      @on:submit="unshiftOfflineMode"
      :key="$route.path"
    />
    <template slot="header">
      <h5 class="modal-title mb-0" id="exampleModalLabel">
        Solicitação de Suporte
        <base-button
          size="sm"
          class="rounded-lg ml-2"
          type="primary"
          @click="CREATE_SUPPORT_DIALOG = true"
        >
          <i class="fa fa-plus"></i>
        </base-button>
      </h5>
    </template>

    <ul class="list-group" v-loading="LOADING">
      <li v-if="filtered_supports.length === 0 && !LOADING && !has_error" class="list-group-item text-center">
        Nenhum chamado encontrado.
      </li>
      <li class="list-group-item" v-for="support in filtered_supports" :key="support.id">
        <div class="row">
          <div class="col-12 col-sm-8">
            <span class="" style="color: rgba(0, 0, 0, 0.8);">{{
              '#'+support.id
            }}</span>
            <br />
            <span class="" style="color: rgba(0, 0, 0, 0.8);">{{
              support.support_claimant.name || "Nome não encontrado"
            }}</span>
            <br />
            <span
              class="text-muted"
              v-b-tooltip.hover.bottom
              :title="support.summary"
            >
              {{
                support && support.summary && support.summary.length > 30
                  ? support.summary.slice(0, 40) + "..."
                  : support.summary || "Sem descrição"
              }}
            </span>
          </div>
          <div class="col-12 col-sm-4 row justify-content-end">
            <div class="text-end">
              {{ FORMAT_DATE_TIME(support.created_at) }}
              <br />
              <span
                :style="
                  'color: ' + FORMAT_STATUS(support.support_ticket_status).color
                "
              >
                {{ FORMAT_STATUS(support.support_ticket_status).label }}
              </span>
              <br />
              <p class="openDetails" @click="openDetails(support)">
                Detalhes
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <modal v-if="selectedSupport" :show.sync="details" id="avaliation-form" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Detalhes do Chamado</h5>
      </template>
      <form role="form">
        <p><strong>Chamado:</strong> #{{ selectedSupport.id }}</p>
        <p><strong>Solicitante:</strong> {{ selectedSupport.support_claimant ? selectedSupport.support_claimant.name : '' }}</p>
        <p><strong>Status:</strong> {{ FORMAT_STATUS(selectedSupport.support_ticket_status).label }}</p>
        <p><strong>Data de Criação:</strong> {{ FORMAT_DATE_TIME(selectedSupport.created_at) }}</p>
        <div class="text-break">
          <p><strong>Resumo:</strong> {{ selectedSupport.summary }}</p>
        </div>
        <p><strong>Anexos:</strong></p>
        <file-list
          :key="selectedSupport.id"
          :files.sync="selectedSupport.media"
          :remove="false"
        />
      </form>
      <template slot="footer">
        <base-button type="secondary" @click="closeDetails">Fechar</base-button>
      </template>
    </modal>
    <div class="row" v-if="SUPPORTS.length === 0 && !LOADING && has_error">
      <div class="col-12 text-center">
        Não foi possível carregar os chamados, tente novamente ou entre em contato com o suporte.
      </div>
      <div class="col-12 text-center pt-2">
        <img class="rounded" style="object-fit: cover;" width="75px" src="../../assets/no-data.png" alt="Uma imagem para referênciar que não existe nenhum suporte criado até o momento" />
      </div>
    </div>

    <template #footer>
      <div class="">
        <base-pagination
          v-model="PAGE"
          :page-count="Math.ceil(PAGES / PER_PAGE) || 1"
          iconLeft="fa fa-angle-double-left"
          iconRight="fa fa-angle-double-right"
          type="success"
        ></base-pagination>
      </div>
    </template>
  </modal>
</template>

<script>
import { VBTooltip } from "bootstrap-vue/esm/directives/tooltip/tooltip";
import { VBPopover } from "bootstrap-vue/esm/directives/popover/popover";
import "bootstrap-vue/dist/bootstrap-vue.min.css";
import CreateSupportDialog from "./Form/Index.vue";
import { ref, onMounted, watch, computed, onBeforeUnmount, getCurrentInstance } from "vue";
import AxiosInstance from "../../backend/axios";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import { DatePicker } from "element-ui";
import FileList from "@/components/FileList";

export default {
  directives: {
    BTooltip: VBTooltip,
    BPopover: VBPopover,
  },
  components: {
    CreateSupportDialog,
    Multiselect,
    [DatePicker.name]: DatePicker,
    FileList,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  setup(props, { emit }) {
    const selected_status = ref(null);
    const proxy = ref(null)
    const selected_date = ref(null);
    const selected_claimant = ref(null);
    var WS_CONNECTION;
    const CURRENT_USER = JSON.parse(localStorage.currentUser);
    const SUPPORTS = ref([]);
  
    const PAGE = ref(1);
    const PAGES = ref(1);
    const PER_PAGE = ref(5);
    const CREATE_SUPPORT_DIALOG = ref(false);
    const SUPPORT_JWT =
      process.env && process.env.VUE_APP_SUPPORT_JWT
        ? process.env.VUE_APP_SUPPORT_JWT
        : null;
    const LOADING = ref(false);
    const WS_CONNECTION_STATE = ref("disconnected");
    const SUPPORT_LENGTH = computed(() => SUPPORTS.value.length);
    const TWENTY_SECONDS_IN_MILLIS = 20 * 1000;
    const CHECK_PING_CONNECTION = setInterval(checkConnection, 15000);
    const LAST_PING = ref(0);
    const ON_CLOSE_DIALOG = () => emit("update:open", false);
    const CLAIMANT_NAMES = ref([]);
    const OPEN_DATES = ref([]);
    const has_error = ref(false)

    const GET_SUPPORT_TICKETS = async () => {
      LOADING.value = true;
      checkPermissions()

      try {
        has_error.value = false;
        const date = new Date(selected_date.value);
        const formattedDate = date.toISOString().split("T")[0];
        const query = {
          support_ticket_status: selected_status.value && selected_status.value.value ? String(selected_status.value.value) : null,
          support_claimant_id: selected_claimant.value && selected_claimant.value? selected_claimant.value.id : null,
          created_at: selected_date.value ? formattedDate : null,
        };

        const RESPONSE = await AxiosInstance.get(
          "/api/v1/support_bridge",
          {
            params: {
              q: query,
              support_claimant_email: CURRENT_USER.email || null,
              software_jwt: SUPPORT_JWT,
              page: PAGE.value,
              per_page: 5,
            },
          }
        );

        if (
          RESPONSE.data &&
          RESPONSE.data.data &&
          Array.isArray(RESPONSE.data.data)
        ) {
          if (
            RESPONSE.data &&
            RESPONSE.data.pagination_params &&
            RESPONSE.data.pagination_params.page
          )
            PAGE.value = Number(RESPONSE.data.pagination_params.page);

          PAGES.value = RESPONSE.data.pagination_params.total || 1;
          SUPPORTS.value = RESPONSE.data.data;
          filtered_supports.value = SUPPORTS.value;
          CLAIMANT_NAMES.value = SUPPORTS.value.map(
            (ticket) => ticket.support_claimant.name
          );
        }
      } catch (error) {
        has_error.value = true;
        console.log('[SUPPORT][GET_SUPPORT_TICKETS]', error);
      }

      LOADING.value = false;
    };

    const GET_SUPPORT_USERS = async () => {
      loadingUsers.value = true;

      try {
        has_error.value = false;

        const RESPONSE = await AxiosInstance.get("/api/v1/support_bridge/users", {
          params: {
            software_id: 3,
            unpaged: true,
            type: "filter"
          },
        });

        users.value = RESPONSE.data
      } catch (error) {
        has_error.value = true;
        console.log("[SUPPORT][GET_SUPPORT_USERS]", error);
      } finally {
        loadingUsers.value = false;
      }
    };

    const loadingUsers = ref(false);
    const users = ref([]);

    const details = ref(false);
    const selectedSupport = ref(null);

    const openDetails = (support) => {
      selectedSupport.value = support;
      details.value = true;
    };
    const closeDetails = () => {
      selectedSupport.value = null;
      details.value = false;
    };

    const clearFilters = async () => {
      selected_status.value = null;
      selected_date.value = null;
      selected_claimant.value = null;
      PAGE.value = 1;
      await GET_SUPPORT_TICKETS();
    };

    const filtered_supports = ref([]);

    const filter = async () => {
      PAGE.value = 1;
      await GET_SUPPORT_TICKETS();
    };

    const FORMAT_STATUS = (status) => {
      return SUPPORT_STATUS.value.find((item) => item.value === status) || SUPPORT_STATUS.value.find((item) => item.value === "default");
    };

    const SUPPORT_STATUS = ref([
      { value: 'open', label: 'Aberto', color: '#007bff' },
      { value: 'in_progress', label: 'Em atendimento', color: '#ffc107' },
      { value: 'closed', label: 'Finalizado', color: '#28a745' },
      { value: 'default', label: 'Pausado', color: '#f4f5f7' },
    ]);

    const FORMAT_DATE_TIME = (dateTime) => {
      if (!dateTime) return "Data não encontrada";

      const day = dateTime.slice(8, 10);
      const month = dateTime.slice(5, 7);
      const year = dateTime.slice(0, 4);
      const time = dateTime.slice(11, 16);

      return `${day}/${month}/${year} às ${time}`;
    };

    const FORMAT_SUPPORT = (support) => {
      return {
        id: support.id || null,
        demand: {
          name: (support.user && support.user.name) || "Não encontrado",
          description: support.description || "{}",
        },
        assigned_to: support.assigned_to || "Não atribuído",
        support_ticket_status: support.support_ticket_status,
        time: support.time || "",
        summary: support.summary || "Sem descrição",
        created_at: support.created_at || null,
      };
    };

    const unshiftOfflineMode = (support) => {
      if (WS_CONNECTION_STATE.value === "disconnected")
        SUPPORTS.value.unshift(FORMAT_SUPPORT(support));
    };

    function connect() {
      const WS = new WebSocket(
        `wss://suporte.spezi.com.br/api/v1/websocket/?software_jwt=${SUPPORT_JWT ||
          null}`
      );

      WS_CONNECTION = WS;

      /**
       * Methods
       *
       * @param {*} event -> Send ws event
       */
      WS.onopen = (event) => {
        if (WS.readyState !== WebSocket.OPEN) {
          console.log("Não foi possível estabelecer conexão com o WebSocket");
          WS.close();

          return;
        }

        WS.send(
          JSON.stringify({
            command: "subscribe",
            identifier: JSON.stringify({
              channel: "SupportChannel",
              software_jwt: SUPPORT_JWT,
            }),
          })
        );
      };

      WS.onmessage = (event) => {
        const DATA = JSON.parse(event.data);

        LAST_PING.value = new Date().getTime();

        if (DATA.message) {
          const message = DATA.message.data;

          if (DATA.type === "confirm_subscription")
            WS_CONNECTION_STATE.value = "connected";

          if (message && message.support_claimant && message.support_claimant.cpf !== CURRENT_USER.cpf) return;

          switch (DATA.message.type) {
            case "save":
              if (WS_CONNECTION_STATE.value === "disconnected")
                WS_CONNECTION_STATE.value = "connected";

              var currentSupport = SUPPORTS.value.find(
                (support) => support.id === message.id
              );

              if (currentSupport) {
                for (let i in FORMAT_SUPPORT(message)) {
                  if (currentSupport[i])
                    currentSupport[i] = FORMAT_SUPPORT(message)[i];
                }

                return;
              }

              if (WS_CONNECTION_STATE.value === "connected")
                SUPPORTS.value.unshift(FORMAT_SUPPORT(message));
              break;
            default:
              return;
          }
        }
      };

      WS.close = () => {
        WS_CONNECTION_STATE.value = "disconnected";

        if (CURRENT_USER)
          console.log("Socket is closed. Reconnect will be attempted again.");
        if (!CURRENT_USER) console.log("Socket is closed.");

        WS.send(
          JSON.stringify({
            command: "unsubscribe",
            identifier: JSON.stringify({
              channel: "SupportChannel",
              software_jwt: SUPPORT_JWT,
            }),
          })
        );
      };

      WS.onerror = function() {
        console.error("Socket encountered error.");
        WS.close();
      };
    }

    /* check if the last ping was more than 20 seconds ago */
    function checkConnection() {
      if (
        new Date().getTime() - LAST_PING.value >= TWENTY_SECONDS_IN_MILLIS &&
        CURRENT_USER && CURRENT_USER.id &&
        WS_CONNECTION_STATE === "disconnected"
      ) {
        connect();
      }
    }

    function checkPermissions() {
      if (
        proxy.value.proxy.$can('show', 'support_bridge') && 
        !proxy.value.proxy.$can('index', 'support_bridge') && 
        !proxy.value.proxy.$can('manage', 'support_bridge')
      ) {
        selected_claimant.value = CURRENT_USER;
      }
    }

    onMounted(async () => {
      proxy.value = getCurrentInstance();
      GET_SUPPORT_USERS()

      if (CURRENT_USER.id) GET_SUPPORT_TICKETS();
      if (CURRENT_USER && CURRENT_USER.id && WS_CONNECTION_STATE.value === "disconnected") connect();
    });

    onBeforeUnmount(() => {
      clearInterval(CHECK_PING_CONNECTION);

      if (WS_CONNECTION && WS_CONNECTION.readyState === WebSocket.OPEN) WS_CONNECTION.close();
    });

    watch(PAGE, () => {
      GET_SUPPORT_TICKETS();
      GET_SUPPORT_USERS();
    });

    watch(SUPPORT_LENGTH, (value) => {
      if (value > 5 && value % 10) return GET_SUPPORT_TICKETS();
      if (value % 5 == 0) GET_SUPPORT_TICKETS();
    });
    watch(() => props.open, (newValue) => {
      if (newValue) {
        GET_SUPPORT_USERS();
      }
    });

    return {
      CURRENT_USER,
      SUPPORTS,
      PAGE,
      PER_PAGE,
      PAGES,
      LOADING,
      FORMAT_STATUS,
      ON_CLOSE_DIALOG,
      FORMAT_DATE_TIME,
      CREATE_SUPPORT_DIALOG,  
      unshiftOfflineMode,
      SUPPORT_STATUS,
      CLAIMANT_NAMES,
      OPEN_DATES,
      selected_status,
      selected_claimant,
      selected_date,
      filtered_supports,
      clearFilters,
      filter,
      users,
      details,
      openDetails,
      selectedSupport,
      closeDetails,
      has_error
    };
  },
};
</script>
<style scoped>
.openDetails{
  cursor: pointer;
  font-weight: 500;
}
.openDetails:hover{
  cursor: pointer;
  color: rgb(24, 23, 23);
  font-weight: 500;
}
.text-break {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
}
:deep(#avaliation-form .modal-dialog) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 auto !important;
  height: 100vh !important;
}
:deep(#avaliation-form .modal-content) {
  position: static !important;
  top: auto !important;
  left: auto !important;
  transform: none !important;
  margin: auto !important;
}
</style>
